import { PeriodicLockReminderModal } from '@components'

import { ReactElement, useEffect } from 'react'

import { useMarkInvoiceStepDoneListener } from '@features/quickStart/hooks'

import { queryClient } from '../../../../config/queryClient'
import { useAutomaticPageTitle } from '../../../../hooks/useAutomaticPageTitle'
import { useBrazeConsentSync } from '../../../../hooks/useBraze/useBrazeConsentSync'
import { useSetBrazeUserIdentity } from '../../../../hooks/useBraze/useSetBrazeUserIdentity'
import { useInvalidateQueriesCustomListener } from '../../../../hooks/useInvalidateQueriesCustomListener'
import { useInvalidateQueriesListener } from '../../../../hooks/useInvalidateQueriesListener'
import { useSetInitialQueryData } from './hooks/useSetInitialQueryData'

export const GlobalUser = (): ReactElement => {
  // Events listeners - mostly used for handling changes in Ember to invalidate some data in React
  // It has to be done in the Menu as it's the only module which is constantly rendered
  useInvalidateQueriesListener()
  useInvalidateQueriesCustomListener()
  useMarkInvoiceStepDoneListener()

  useAutomaticPageTitle()
  // setting queries for user organization and accounts based on data already loaded by Ember
  useSetInitialQueryData()

  useSetBrazeUserIdentity()
  useBrazeConsentSync()

  // clear cache on mount and unmount - ensures fresh data after logout/login cycles
  useEffect(() => {
    // Those clears are intentional - helping resetting the state on react unmount/mount
    queryClient.clear()

    return () => {
      // Those clears are intentional - helping resetting the state on react unmount/mount
      queryClient.clear()
    }
  }, [])

  // Here add anything that needs to be present in DOM when the user is logged in
  return <PeriodicLockReminderModal />
}
